// extracted by mini-css-extract-plugin
export var checkoutHoverCard = "_mx-2";
export var interactiveWrapper = "_mx-0";
export var shippingHoverPreview = "_mx-4";
export var summaryBadgeTrigger = "_mx-1";
export var widgetHoverPreviewList = "_mx-3";
export var widgetPreviewScale = "_mx-5";